<template>
  <main>
    <div class="row details-payment">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template v-slot:left-element>
            <h3>{{ $t('title.detailsPayment') }} {{ fullname }}</h3>
          </template>

          <template v-slot:right-element>
            <div class="d-flex buttons-wrapper">
              <a @click="$router.go(-1)" class="btn btn-outline-primary button" :disabled="loading">
                <i class="arrow left"></i>
                {{ $t('button.retour') }}
              </a>
              <router-link
                :to="{
                  name: 'AddPayment',
                  params: {id: referenceId},
                }"
                class="btn button btn-primary"
              >
                <i class="icon-Add"></i>
                {{ $t('button.addPayment') }}
              </router-link>
            </div>
          </template>
        </TopTemplate>
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-if="!loading && reference">
          <!-- Tabs navs -->
          <div class="table message-list">
            <div class>
              <div class="row">
                <div class="col-md-12 table__wrapper">
                  <b-card no-body v-if="!loading && years">
                    <nav>
                      <div class="nav nav-tabs list-nav-pay" id="nav-tab" role="tablist">
                        <button
                          class="nav-link"
                          id="nav-home-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-home"
                          @click="listPaymentsByYear($event, year.id)"
                          type="button"
                          role="tab"
                          aria-controls="nav-home"
                          aria-selected="true"
                          v-for="(year, index) in years"
                          :key="index"
                          :class="{active: index + 1 === years.length}"
                        >
                          {{ year.name }}
                        </button>
                      </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                      <div class="tab-pane fade show active">
                        <div v-if="loadingPayment" class="card mt-4 text-center d-block pt-4 pb-4">
                          <div class="spinner-border text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                        <div class="table" v-if="!loadingPayment && referenceYearsParentJSON.length === 0">Pas de paiements</div>
                        <div class="table" v-else>
                          <div>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="table__wrapper">
                                  <table v-if="!loadingPayment" class="table__classes">
                                    <thead>
                                      <tr class="item_class">
                                        <th>{{ $t('paiement.tab.date') }}</th>
                                        <th>{{ $t('paiement.tab.wording') }}</th>
                                        <th>{{$t('paiement.tab.debit')}}</th>
                                        <th>{{ $t('paiement.tab.credit') }}</th>
                                       <!-- <th>{{ $t('paiement.tab.action') }}</th>-->

                                        <!-- <th class="action text-end">Actions</th> -->
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr v-for="(ref, index) in referenceYearsParentJSON" :key="index" :class="{ 'payment': ref.status === 1, 'solde-paym': ref.status === 2 }"  class="item_class is_credit">
                                        <td v-if="ref.status === 1 || ref.status !== 2">
                                          {{ formatDate(ref.payment_date) }}
                                        </td>
                                        <td v-if="ref.status === 2">__</td>
                                        <td>
                                          {{ ref.wording }}
                                        </td>
                                        <td>
                                          <span class="tire_value" v-if="ref.type == 0">{{ ref.amount.toFixed(3) }}</span>
                                          <span class="tire" v-else>__</span>
                                        </td>
                                        <td>
                                          <span class="tire_value" v-if="ref.type == 1">{{ ref.amount.toFixed(3) }} </span>
                                          <span class="tire" v-else>__</span>
                                        </td>
                                       <!-- <td>
                                          <span class="tire_value">  <i
                                            class="icon-trash"
                                            style="margin-right: 0"
                                          >
                                            <span class="tooltiptext">Supprimer</span>
                                          </i> </span>
                                        </td>-->

                                        <!-- <td class="action text-end">
                        <i class="icon-trash">
                          <span class="tooltiptext"
                            >Supprimer</span
                          >
                        </i>
                      </td> -->
                                      </tr>
                                      <tr v-if="!loadingPayment && referenceYearsParentJSON.length > 0" class="card_somme_1">
                                        <td>
                                          <span class="text_somme is_solde">{{ $t('paiement.tab.total') }}</span>
                                        </td>
                                        <td></td>
                                    
                                        <td>
                                          <span  v-if="referenceYearsParentJSON.length === 0" class="text_debit">0.000</span>
                                          <span  v-else class="text_debit is_solde">{{ sommeDebit.toFixed(3) }}</span>
                                        </td>
                                        <td>
                                          <span  v-if="referenceYearsParentJSON.length === 0" class="text_debit">0.000</span>
                                          <span  v-else class="text_debit is_solde">{{ sommeCredit.toFixed(3) }}</span>
                                        </td>
                                        <td></td>
                                      </tr>
                                      <tr v-if="!loadingPayment && referenceYearsParentJSON.length > 0" class="card_somme_2">
                                        <td>
                                          <span class="text_somme is_Total">{{ $t('paiement.tab.solde') }}</span>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <span  v-if="referenceYearsParentJSON.length === 0" class="text_debit">0.000</span>
                                          <span  v-else class="text_total is_Total">{{ (sommeCredit - sommeDebit).toFixed(3)  }}</span>
                                        </td>
                                        <td></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabs content -->
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import PaymentService from "../../services/payment.service";
import StudentService from "../../services/student.service";
import {isProxy, toRaw} from "vue";
import moment from "moment";
export default {
  name: "DetailsPayment",
  components: {
    TopTemplate,
  },
  data() {
    return {
      referenceId: null,
      reference: {},
      referenceYear: {},
      years: [],
      referenceYearsParent: [],
      referenceYearsParentJSON: [],
      calculSomme: 0,
      tabActive: 0,
      sommeCredit: 0,
      sommeDebit: 0,
      loading: false,
      loadingPayment: false,
      yearScolaire: null,
      school_years: [],
      payments: [],
      fullname: "",
      params: {
        sort: "created_at",
        order: false,
      },
      moment: null,
    };
  },
  created() {
    this.moment = moment;
    this.referenceId = this.$route.params.id;
  },
  mounted() {
    this.getDetailsYear();
  },
  methods: {
    formatDate(date) {
      if(!date) return '__';
      moment.locale("fr");
      return moment(date).format("DD-MM-YYYY");
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListServices();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListServices();
    },
    /*  onTabChanged(e,title) {
      this.tabActive = this.years.length - 1;
    }, */
    listPaymentsByYear(e, id) {
      this.referenceYearsParentJSON = [];
      this.referenceYear = [];
      this.loadingPayment = true;
      PaymentService.getYear(id, this.referenceId, {
        params: {
          sort: this.params.sort,
          order: this.params.order,
        },
      })
        .then((response) => {
          this.referenceYear = response.data.data[0];
          this.fullname = this.referenceYear.student.first_name + " " + this.referenceYear.student.last_name;
          if (this.referenceYear.payment.length > 0) {
            this.sommeDebit = 0;
            this.sommeCredit = 0;
            this.referenceYearsParentJSON = this.referenceYear.payment;
            this.referenceYearsParentJSON.forEach((element) => {
              if (element.type == 0) {
                this.sommeDebit = this.sommeDebit + element.amount;
              } else {
                this.sommeCredit = this.sommeCredit + element.amount;
              }
            });
           
          } else if (this.referenceYear.payment.length === 0) {
          
            this.referenceYear = [];
            this.referenceYearsParentJSON = [];
          }
        })
        .catch((error) => {
          console.error(error);
            if (error.response && error.response.status === 404) {
              this.$router.push('/error-404');
            }
        }).finally(()=>{
          this.loadingPayment = false;
        });
    },

    getDetailsYear(e) {
      this.loading = true;
      PaymentService.getSchoolSession().then(
        (response) => {
          this.years = response.data.data.reverse();
          this.listPaymentsByYear(e, this.years[this.years.length - 1].id);
        }
      ).catch((error) => {
           console.log(error)
        }).finally(()=>{
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.payment.is_credit{
  background-color: #F1FAFA !important;
}
.nav-tabs{
  display: flex;
  justify-content: center;
}
.nav-link.active{
  border: none;
  background: none;
  border-bottom: 2px solid #377879 !important;
  color: #377879;
}
.nav-link{
  color: #000000;
  font-weight: 700;
  padding-left: 0;
  padding-right: 0;
  margin: 0 15px;
}
.nav-tabs .nav-link{
  border: none;
}
.nav-link:focus{
  border: none;
}
.nav-link:hover{
  border: none;
}
.card{
  background: none;
}
.card nav{
  background: #fff;
  padding-bottom: 19px;
  margin-left: 13px;
  margin-right: 13px;
}
.table .table__wrapper{
  padding: 0;
}
.details-payment .table .table__wrapper thead > tr > th {
    padding: 15px 15px;
}
.table__wrapper .tab-content{
  padding: 0;
  margin-top: 3px;
}
.tab-content .table{
  padding: 0 17px;
}
.table__wrapper .table__classes .item_class th{
  padding:  15px 40px !important;
  width: 25%;
}
.table table td{
  padding: 13px 40px !important;
  width: 25%;
}
</style>